import { render, staticRenderFns } from "./WriteContentModal.vue?vue&type=template&id=6c457b52&"
import script from "./WriteContentModal.vue?vue&type=script&lang=ts&"
export * from "./WriteContentModal.vue?vue&type=script&lang=ts&"
import style0 from "./WriteContentModal.vue?vue&type=style&index=0&id=6c457b52&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports